const selectFreightP2PModalData = (state) => state.offersLane.freightP2PModal;

export { selectFreightP2PModalData };
